import { Component } from '@angular/core';

@Component({
  selector: 'app-home-pannel',
  templateUrl: './home-pannel.component.html',
  styleUrls: ['./home-pannel.component.scss']
})
export class HomePannelComponent {

}
